import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';
import Link from '../framework/link';
import SectionHeader from '../framework/sections/section-header';
import Slider from '../framework/slider';

const cardsByType = {
	business: [
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/06/23/tittar-i-telefon-937.jpg',
			subtitle: 't30',
			title: 't31',
		},
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/06/25/man-tar-blodprov-i-armen-950.jpg',
			subtitle: 't32',
			title: 't33',
		},
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/06/23/aldre-man-far-provsvar-938.jpg',
			subtitle: 't34',
			title: 't35',
		},
	],
	ecg: [
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/05/26/how-it-works-zample-2-876.jpg',
			subtitle: 't14',
			title: 't13',
		},
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/05/26/how-it-works-zample-stats-881.jpg',
			subtitle: 't16',
			title: 't15',
		},
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/05/26/how-it-works-zample-no-app-880.jpg',
			subtitle: 't18',
			title: 't17',
		},
	],
	mri: [
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/05/28/how-it-works-xray-buy-889.jpg',
			subtitle: 't8',
			title: 't7',
		},
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/04/08/mr-rontgen-738.jpg',
			subtitle: 't10',
			title: 't9',
		},
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/05/26/how-it-works-zample-no-app-880.jpg',
			subtitle: 't12',
			title: 't11',
		},
	],
	service: [
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/05/26/how-it-works-zample-2-876.jpg',
			subtitle: 't2',
			title: 't1',
		},
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/05/26/how-it-works-zample-stats-881.jpg',
			subtitle: 't4',
			title: 't3',
		},
		{
			imgSrc:
				'https://cdn.testmottagningen.se/assets/2025/05/26/how-it-works-zample-no-app-880.jpg',
			subtitle: 't6',
			title: 't5',
		},
	],
};

const HowItWorksFeature = ({
	enableReadMore,
	enableTitle,
	type = 'service',
}) => {
	const { t } = useTranslation('component_how_it_works_feature');

	const readMoreLinks = {
		ecg: 'langtids-ekg',
		mri: 'rontgen',
		service: 'zample',
	};

	const sectionHeaderMap = {
		blood_sample: {
			subTitle: t('20'),
			title: t('t21'),
		},
		business: {
			subTitle: t('t28'),
			title: t('t29'),
		},
		ecg: {
			subTitle: t('t22'),
			title: t('t23'),
		},
		mri: {
			subTitle: t('t24'),
			title: t('t25'),
		},
		service: {
			subTitle: t('t26'),
			title: t('t27'),
		},
	};

	const readMoreLink = readMoreLinks[type] || readMoreLinks['service'];
	const sectionHeader = sectionHeaderMap[type] || sectionHeaderMap['service'];

	const cards = cardsByType[type] || [];

	return (
		<>
			{enableTitle && (
				<SectionHeader
					align="center"
					headingType="p"
					hideButton={true}
					size="lg"
					subHeadingType="h3"
					subTitle={sectionHeader.subTitle}
					title={sectionHeader.title}
				/>
			)}
			<Slider mobile_only>
				<div className="d-flex">
					{cards.map((card, index) => (
						<div className="slider-card-grid card-featured" key={index}>
							<div className="mb-3">
								<img
									alt={card.title}
									className="img-fluid rounded-3 o-hidden"
									src={card.imgSrc}
								/>
							</div>

							<h3 className="title-xs sm text-break white-space-break">
								{t(card.title)}
							</h3>
							<p className="sm text-muted text-break white-space-break">
								{t(card.subtitle)}
							</p>
						</div>
					))}
				</div>
			</Slider>
			{enableReadMore && (
				<div className="d-flex justify-content-center mt-4">
					<Link
						className="text-decoration-none  btn-lg btn btn-outline-dark rounded-pill "
						iconSize="md"
						labelSize="sm"
						linkType="div"
						to={`/sa-fungerar-det/${readMoreLink}`}
					>
						{t('t19')}
					</Link>
				</div>
			)}
		</>
	);
};

HowItWorksFeature.propTypes = {
	enableReadMore: PropTypes.bool,
	enableTitle: PropTypes.bool,
	type: PropTypes.oneOf(['mri', 'service', 'ecg']),
};

export default HowItWorksFeature;
